import React from "react";
import { List } from "react-virtualized";
import { removeAccents } from "../common/Helpers/StringHelper";
import { PropTypes } from "react/lib/React";

class ClientHeaderSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      search: "",
      selectedClient: props.selectedClient || props.clients[0] || null,
    };

    this.container = null;
    this.searchInput = null;

    this.setContainerRef = this.setContainerRef.bind(this);
    this.setSearchInputRef = this.setSearchInputRef.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleClientSelect = this.handleClientSelect.bind(this);
    this.getFilteredClients = this.getFilteredClients.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUpdate(nextProps) {
    if (
      this.props.selectedClient &&
      nextProps.selectedClient &&
      this.props.selectedClient.value !== nextProps.selectedClient.value
    ) {
      this.setState({
        selectedClient: {
          value: nextProps.selectedClient.value,
          label: nextProps.selectedClient.label,
        },
      });
    }
  }

  setContainerRef(node) {
    this.container = node;
  }

  setSearchInputRef(node) {
    this.searchInput = node;
  }

  handleClickOutside(event) {
    if (this.container && !this.container.contains(event.target)) {
      this.closeDropdown();
    }
  }

  toggleOpen() {
    this.setState(
      function (prevState) {
        return { isOpen: !prevState.isOpen };
      },
      function () {
        if (this.state.isOpen && this.searchInput) {
          this.searchInput.focus();
        }
      },
    );
  }

  closeDropdown() {
    this.setState({
      isOpen: false,
      search: "",
    });
  }

  handleSearchChange(event) {
    this.setState({
      search: event.target.value,
    });
  }

  handleClientSelect(client) {
    this.setState({
      selectedClient: client,
      isOpen: false,
      search: "",
    });

    if (this.props.onClientChange) {
      this.props.onClientChange(client);
    }
  }

  getFilteredClients() {
    let clients = this.props.clients || [];
    let search = removeAccents((this.state.search || "").toLowerCase());

    if (!search) {
      return clients;
    }

    return clients.filter(function (client) {
      return (
        removeAccents((client.label || "").toLowerCase()).indexOf(search) !== -1
      );
    });
  }

  rowRenderer(rowProps) {
    let index = rowProps.index;
    let key = rowProps.key;
    let style = rowProps.style;
    let clients = this.getFilteredClients();
    let client = clients[index];
    let selectedClient = this.state.selectedClient;
    let isSelected =
      selectedClient && Number(selectedClient.value) === Number(client.value);

    return (
      <div
        key={key}
        style={style}
        className={"client-header-option" + (isSelected ? " is-selected" : "")}
        title={client.label}
        onClick={this.handleClientSelect.bind(this, client)}
      >
        {client.label}
      </div>
    );
  }

  render() {
    let filteredClients = this.getFilteredClients();
    let selectedClient = this.state.selectedClient;
    let rowHeight = 36;
    let listHeight = Math.min(filteredClients.length * rowHeight, 216);

    return (
      <div className="client-header-selector" ref={this.setContainerRef}>
        <button
          type="button"
          className="client-header-trigger"
          onClick={this.toggleOpen}
        >
          <span
            title={selectedClient ? selectedClient.label : ""}
            className="client-header-text"
          >
            {selectedClient ? selectedClient.label : "Select client"}
          </span>
          <span className="client-header-arrow">
            {this.state.isOpen ? "▲" : "▼"}
          </span>
        </button>

        {this.state.isOpen && (
          <div className="client-header-dropdown">
            <div className="client-header-search-wrap">
              <input
                ref={this.setSearchInputRef}
                type="text"
                className="client-header-search"
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>

            {filteredClients.length > 0 && (
              <div className="client-header-list">
                <List
                  width={260}
                  height={listHeight}
                  rowCount={filteredClients.length}
                  rowHeight={rowHeight}
                  rowRenderer={this.rowRenderer}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

ClientHeaderSelector.propTypes = {
  clientSelectorClient: PropTypes.object,
  clients: PropTypes.array,
  onClientChange: PropTypes.func,
  selectedClient: PropTypes.object,
};

export default ClientHeaderSelector;



// WEBPACK FOOTER //
// ./src/components/dashboard/ClientHeaderSelector.js